import _jsx from "@babel/runtime/helpers/jsx";
import React from 'react';
import clsx from 'clsx';
import Button from '../Button/index.js';
import Image from '../Image/index.js';
function BodyStyleButton(_ref) {
  let {
    image = {},
    children,
    className,
    ...rest
  } = _ref;
  const {
    imageSrc = '',
    width,
    height
  } = image ?? {};
  className = clsx(className, 'text-sm-left padding-left-sm-3 overflow-hidden');
  if (!image || !imageSrc || imageSrc === '') {
    return /*#__PURE__*/React.createElement(Button, Object.assign({
      className: className
    }, rest), children);
  }
  return /*#__PURE__*/React.createElement(Button, Object.assign({
    bsStyle: "secondary",
    className: className
  }, rest), children, /*#__PURE__*/_jsx(Image, {
    src: imageSrc,
    lazyload: false,
    alt: "",
    width: width || '60px',
    height: height || '28px',
    "aria-hidden": "true",
    className: "display-inline margin-left-5 vertical-align",
    style: {
      marginTop: '-10px',
      marginBottom: '-10px'
    }
  }));
}
export default BodyStyleButton;